import { render, staticRenderFns } from "./date.vue?vue&type=template&id=59522caa"
import script from "./date.vue?vue&type=script&lang=ts"
export * from "./date.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports